// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.title::after {
  height: var(--unit-xxxsm);
  bottom: calc(var(--unit-xxxsm) * -1);
}
ion-header.title ion-title {
  color: var(--Brand-Primario, #0554F2);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  top: 22px;
}
ion-header.title .subtitle {
  padding-inline: var(--unit-lg);
  width: 100%;
}
ion-header.title .subtitle ion-label {
  font-size: var(--font-md);
  font-weight: 400;
  --color: var(--ion-color-info-text);
}

ion-toolbar .close-icon {
  width: 32px;
  height: 32px;
}

.ios-modal ion-toolbar:first-of-type {
  padding-top: 10px !important;
}

.config-title {
  color: var(--ion-color-primary);
}

.no-qr {
  width: 229px;
  height: 239px;
  text-align: center;
  background: #fff;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.no-qr ion-spinner {
  margin: 0 auto;
  top: 0;
  bottom: 0;
}

ion-header ion-toolbar {
  --background: #fff;
}
ion-header ion-toolbar ion-icon {
  margin-right: 24px;
  width: 32px;
  height: 32px;
}

ion-header.search {
  background: transparent;
  padding: var(--unit-md);
}
ion-header.search::after {
  background-image: none;
}

ion-content {
  --background: var(--ion-color-primary-contrast);
  --padding-bottom: var(--unit-xxxsm);
}

ion-footer {
  --background: transparent;
}
ion-footer ion-toolbar {
  --border-width: 0;
  --padding-end: 0;
  --padding-start: 0;
  border-top-left-radius: var(--radius-md);
  border-top-right-radius: var(--radius-md);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
}
ion-footer ion-grid ion-button {
  width: auto;
}

ion-col.value {
  font-weight: 600;
}

span.no-wrap {
  white-space: initial;
}

.multiAccordion ion-list[slot=content] {
  border-bottom: 1px solid var(--ion-item-border-color);
}
.multiAccordion:last-of-type ion-item[slot=header] {
  --border-color: var(--ion-item-border-color);
  --border-style: solid;
  --border-width: 0 0 1px 0;
}
.multiAccordion.accordion-expanding:last-of-type ion-item[slot=header], .multiAccordion.accordion-expanded:last-of-type ion-item[slot=header] {
  --border-width: 0;
}
.multiAccordion.accordion-expanding:last-of-type ion-list[slot=content], .multiAccordion.accordion-expanded:last-of-type ion-list[slot=content] {
  border-bottom: none;
}

.btn-flag {
  margin-right: var(--unit-xsm);
  height: calc(var(--unit-md) + 2px);
  border-radius: var(--radius-xxsm);
}

ion-icon[slot=start] {
  font-size: var(--unit-xxxlg);
  width: var(--unit-xxxlg);
  height: var(--unit-xxxlg);
  margin-inline-end: 0;
}
ion-icon[slot=start].opt {
  color: #ffffff;
  background: var(--ion-color-primary);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 10px;
}
ion-icon[slot=start].custom {
  color: #ffffff;
  background: var(--ion-color-primary);
  width: 22px;
  height: 22px;
  padding: 6px;
  border-radius: 50%;
  margin-right: 10px;
}
ion-icon[slot=start].clean {
  width: 24px !important;
  height: 24px !important;
  padding: 6px;
  border-radius: 50%;
  margin-right: 10px;
  background: #ffffff;
  margin-bottom: 8px;
  position: relative;
  bottom: 4px;
}
ion-icon[slot=start].icon-VENTASCLICK {
  color: #3889F2;
}
ion-icon[slot=start].icon-default {
  color: var(--ion-color-primary);
}

.error-advice {
  color: var(--ion-color-danger);
}

#containerQR {
  position: absolute;
  top: 0px;
  z-index: 9;
  margin: 0 auto;
  width: 100%;
}
#containerQR p {
  color: #FFF;
  font-family: Montserrat;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.009px;
  margin: 16px 26px 31px 26px;
}

section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  padding-top: 100px;
  background: var(--ion-color-primary);
}

.curve {
  position: absolute;
  height: 250px;
  width: 100%;
  bottom: 0;
  text-align: center;
}

.curve::before {
  content: "";
  display: block;
  position: absolute;
  border-radius: 169% 159%;
  width: 150%;
  height: 67%;
  left: 0px;
  bottom: 21px;
  transform: translate(-16%, 62%);
  background-color: #ffffff;
}

.boxx-btn {
  height: 13vw !important;
  min-height: 13vw !important;
  margin: 0px 4px;
}

.btn-register {
  --border-radius: 16px;
  margin-bottom: 24px;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: math-auto;
}

.btn-manual {
  font-weight: 500;
}

.attendee-avatar-container {
  display: flex;
  align-items: flex-end;
  white-space: initial;
  font-size: small;
}
.attendee-avatar-container ion-avatar {
  min-width: 24px;
  width: 24px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 6px;
  padding: 0;
  border: 0;
}
.attendee-avatar-container ion-avatar div {
  background: var(--ion-color-primary);
  color: #ffffff;
}

.container-detail {
  border-radius: 8px;
  background: #FFF;
  padding: 0px 24px 16px 24px;
}
.container-detail .detail-title {
  color: #07192F;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  margin-bottom: 8px;
  margin-top: 0px;
}
.container-detail .detail-dates {
  color: #F20F0F;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.container-detail .detail-title-form {
  color: #0C2340;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-top: 11px;
  margin-bottom: 8px;
}
.container-detail .detail-desc {
  color: #43556A;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-top: 8px;
}
.container-detail .detail-link {
  color: var(--ion-color-primary);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-top: 8px;
}
.container-detail .container-actions {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-left: 20px;
}

.qr-container {
  margin-top: -9px;
}
.qr-container img {
  min-width: 297px;
  min-height: 297px;
}

.sw-qr {
  position: absolute;
  top: 0px;
  z-index: 9;
  margin: 0 auto;
  width: 100%;
}

#contact-type {
  padding: 0px 16px;
}
#contact-type ion-item {
  --padding-start: 0px;
  --padding-end: 0px;
}
#contact-type .icon-type {
  width: 32px;
  height: 32px;
  padding-right: 18px;
}
#contact-type ion-label {
  color: var(--text-Subttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#contact-type .unqualified {
  color: #515356;
}
#contact-type .prospect {
  color: #FF9900;
}
#contact-type .client {
  color: #00A569;
}
#contact-type .discarded {
  color: #DC3839;
}

#custom-options {
  padding: 0px 24px;
}
#custom-options ion-item {
  --padding-start: 0px;
  --padding-end: 0px;
}
#custom-options ion-item .c-detail {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 2px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-overflow: inherit;
  overflow: inherit;
  color: var(--ion-color-step-600, #666666);
}
#custom-options .icon-src {
  width: 32px;
  height: 32px;
  padding: 6px;
  border-radius: 50%;
  margin-right: 10px;
  background: #ffffff;
  margin-bottom: 8px;
}
#custom-options ion-label {
  color: var(--text-Subttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 5px;
  margin-top: 9px;
}
#custom-options .subtitle {
  color: #000;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  margin: 0px;
  padding: 0px 40px;
  margin-bottom: 10px;
}
#custom-options .benefit {
  color: #000;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 11px 0px;
}

.completed {
  color: #099F69;
}

.to-do {
  color: #D50000;
}

.in-progress {
  color: #C97B07;
}

.high {
  background: #EC0000 !important;
}

.low {
  background: #0554F2 !important;
}

.half {
  background: #FF8A00 !important;
}

#containerQR {
  position: absolute;
  top: 0px;
  z-index: 9;
  margin: 0 auto;
  width: 100%;
}
#containerQR .cont-img {
  position: relative;
}
#containerQR .cont-img .img-nfc {
  width: 81%;
  margin-top: 17px;
}
#containerQR .cont-img .mt-success {
  margin-top: 17%;
  margin-bottom: 14px;
}
#containerQR .success {
  position: absolute;
  top: 32%;
  left: 50%;
  width: 32%;
  transform: translate(-50%, -50%);
}
#containerQR .tt-none {
  text-transform: none;
}
#containerQR p {
  color: #FFF;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.009px;
  margin: 8px 26px 31px 26px;
  font-family: "Poppins";
  font-size: 30px;
}
#containerQR .nfc-text {
  color: #FFF;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.009px;
  margin: 12px 39px 23px 39px;
}
#containerQR .nfc-detail {
  color: #FFF;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 2px 74px;
  margin-bottom: 73px;
}

section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  padding-top: 100px;
  background: var(--ion-color-primary);
}

.curve {
  position: absolute;
  height: 250px;
  width: 100%;
  bottom: 0;
  text-align: center;
}

.curve::before {
  content: "";
  display: block;
  position: absolute;
  border-radius: 169% 159%;
  width: 150%;
  height: 67%;
  left: 0px;
  bottom: 21px;
  transform: translate(-16%, 62%);
  background-color: #ffffff;
}

.nfc-item-form {
  margin-bottom: 16px;
  --padding-start: 16px;
  --padding-end: 16px;
  border-radius: 8px;
  border: 1px solid #076DF2;
  background: #FFF;
}

.nfc-item-form ::ng-deep .custom-input .label-text {
  color: #0554F2 !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
}
.nfc-item-form ::ng-deep .custom-input {
  color: #2C4051;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.custom-input::part(native) {
  color: gray;
  /* Para el texto del prefijo */
}

#container-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #f0f0f0;
}
#container-actions .cancel,
#container-actions .accept {
  color: var(--ion-color-primary);
  text-align: right;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.4px;
  font-size: 14px !important;
  text-transform: initial;
}
#container-actions .title {
  color: #000;
  text-align: center;
  font-family: "Poppins";
  font-size: 14px !important;
  text-transform: initial;
  font-style: normal;
  font-weight: 590;
  line-height: 18px;
}

.custom-search-bar {
  padding: 0px 16px;
  --padding-top: 0px;
}
.custom-search-bar ion-searchbar {
  border-radius: 16px;
  --border-radius: 16px;
  height: 56px;
  --padding-start: 16px;
  --padding-end: 16px;
  border: 2px solid #ede9e9;
  min-height: 56px;
  margin: 0px;
}

.search-form {
  background: transparent;
}
.search-form .custom-item-form ::ng-deep .custom-input .label-text {
  color: #0D253A !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
}
.search-form .custom-item-form ::ng-deep .custom-input {
  color: #0D253A !important;
  font-family: "Poppins";
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
}
.search-form .custom-item-form {
  border: 2px solid #ede9e9;
  margin-bottom: 8px;
  --border-radius: 50px;
  height: 40px;
  --padding-start: 16px;
  --padding-end: 16px;
  border-radius: 12px;
  background: var(--Input-Box-Empty-Abled, #FFF);
  box-shadow: 0px 0px 3px 1px rgba(83, 127, 171, 0.2) inset;
}
.search-form .custom-item-form .custom-input {
  resize: none;
  bottom: 17px;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 40px;
}
.search-form .custom-item-form .custom-search-icon {
  margin: 0px;
  position: relative;
  bottom: 16px;
  width: 20px;
}

#content-schedule {
  padding: 16px 24px;
  background: #fff;
  --padding-bottom: 56px;
}
#content-schedule .title {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
#content-schedule hr {
  background: #D8D8D8;
}
#content-schedule ion-datetime {
  margin: 0 auto;
  background: #f8f9fb;
}
#content-schedule .date-content {
  width: 100%;
  float: none;
  z-index: 9;
}
#content-schedule .time-content {
  width: 100%;
  float: none;
}
#content-schedule .label-date {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}
#content-schedule .label-time {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}
#content-schedule .buttonPWA {
  display: none;
}
#content-schedule .buttonMobile {
  display: block;
}
@media (min-width: 960px) {
  #content-schedule .label-date {
    display: none;
  }
  #content-schedule .label-time {
    display: none;
  }
  #content-schedule .date-content {
    width: 50%;
    float: left;
  }
  #content-schedule .time-content {
    width: 50%;
    float: right;
  }
  #content-schedule .time-pwa {
    padding-top: 12%;
  }
  #content-schedule .buttonPWA {
    display: block;
  }
  #content-schedule .buttonMobile {
    display: none;
  }
}
#content-schedule .boxx-btn {
  text-transform: uppercase;
}
#content-schedule .custom-title {
  color: var(--ion-color-light) !important;
}
#content-schedule .enable-item {
  border-radius: 0px;
  border: none;
}
#content-schedule .enable-item ion-label {
  color: #425F81 !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: relative;
  top: 3px;
}
#content-schedule .enable-item .hour {
  color: #12384F !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  position: relative;
  top: 3px;
}
#content-schedule ion-toggle {
  --background: #dfdfdf !important;
  --background-checked: var(--ion-color-primary) !important;
  --handle-background: #ffffff !important;
  --handle-background-checked: #fff !important;
}
#content-schedule ion-toggle[slot=end] {
  margin-top: 12px;
  margin-bottom: 12px;
  padding: 0;
}

swiper-container {
  --swiper-pagination-bottom: 30px;
  --swiper-pagination-bullet-width: 16px;
  --swiper-pagination-bullet-height: 16px;
}

.languages-list {
  margin: 0px 16px;
}
.languages-list ion-item {
  --padding-start: 8px;
  --padding-end: 8px;
}
.languages-list ion-item ion-label {
  color: var(--text-Subttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  /* Body/Body Resultados */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

#gbp-options {
  padding: 0px 16px;
}
#gbp-options .custom-main-title {
  color: var(--text-BODY, #2C4051);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  padding: 0px 24px;
  margin-top: 8px;
}
#gbp-options div {
  background-color: white;
  border-radius: 16px;
  padding: 16px;
  margin: 10px 0;
  width: 100%;
  fill: var(--Color-cards, #FFF);
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.15));
  margin-bottom: 16px;
}
#gbp-options .index-selected {
  border: 1px solid blue;
}
#gbp-options .name {
  color: var(--text-Ttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 0px;
}
#gbp-options .category {
  color: var(--text-Info, #788089);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 0px;
}
#gbp-options hr {
  background: #D8D8D8;
}
#gbp-options .title {
  color: var(--text-Ttulos, #0D253A);
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 2px;
}
#gbp-options .detail {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/bottom-sheet/bottom-sheet.component.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,oCAAA;AAAJ;AAGE;EACE,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAIE;EACE,8BAAA;EACA,WAAA;AAFJ;AAII;EACE,yBAAA;EACA,gBAAA;EACA,mCAAA;AAFN;;AAOA;EACE,WAAA;EACA,YAAA;AAJF;;AAOA;EACE,4BAAA;AAJF;;AAOA;EACE,+BAAA;AAJF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAJF;AAME;EACE,cAAA;EACA,MAAA;EACA,SAAA;AAJJ;;AASE;EACE,kBAAA;AANJ;AAQI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AANN;;AAWA;EACE,uBAAA;EACA,uBAAA;AARF;AAUE;EACE,sBAAA;AARJ;;AAYA;EACE,+CAAA;EACA,mCAAA;AATF;;AAYA;EACE,yBAAA;AATF;AAWE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;AATJ;AAaI;EACE,WAAA;AAXN;;AAgBA;EACE,gBAAA;AAbF;;AAgBA;EACE,oBAAA;AAbF;;AAiBE;EACE,qDAAA;AAdJ;AAkBI;EACE,4CAAA;EACA,qBAAA;EACA,yBAAA;AAhBN;AAuBM;EACE,iBAAA;AArBR;AAwBM;EACE,mBAAA;AAtBR;;AA4BA;EACE,6BAAA;EACA,kCAAA;EACA,iCAAA;AAzBF;;AA4BA;EACE,4BAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;AAzBF;AA2BE;EASE,cAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAjCJ;AAoCE;EACE,cAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAnCJ;AAsCE;EACE,cAAA;AApCJ;AAuCE;EACE,+BAAA;AArCJ;;AAyCA;EACE,8BAAA;AAtCF;;AA2CA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;AAxCF;AA0CE;EACE,WAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;AAxCJ;;AA4CA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AAzCF;;AA4CA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AAzCF;;AA4CA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,+BAAA;EACA,yBAAA;AAzCF;;AA6CA;EACE,uBAAA;EACA,2BAAA;EACA,eAAA;AA1CF;;AA6CA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AA1CF;;AA6CA;EACE,gBAAA;AA1CF;;AA6CA;EACE,aAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;AA1CF;AA4CE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;AA1CJ;AA4CI;EACE,oCAAA;EACA,cAAA;AA1CN;;AA+CA;EACE,kBAAA;EACA,gBAAA;EAEA,2BAAA;AA7CF;AA+CE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA7CJ;AAgDE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AA9CJ;AAiDE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA/CJ;AAkDE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAhDJ;AAmDE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAjDJ;AAoDE;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;AAlDJ;;AAuDA;EACE,gBAAA;AApDF;AAsDE;EACE,gBAAA;EACA,iBAAA;AApDJ;;AAwDA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;AArDF;;AA0DA;EAEE,iBAAA;AAxDF;AA0DE;EACE,oBAAA;EACA,kBAAA;AAxDJ;AA4DE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA1DJ;AA6DE;EACE,qCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA3DJ;AA8DE;EACE,cAAA;AA5DJ;AA+DE;EACE,cAAA;AA7DJ;AAgEE;EACE,cAAA;AA9DJ;AAiEE;EACE,cAAA;AA/DJ;;AAmEA;EAEE,iBAAA;AAjEF;AAmEE;EACE,oBAAA;EACA,kBAAA;AAjEJ;AAmEI;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yCAAA;AAjEN;AAqEE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAnEJ;AAsEE;EACE,qCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AApEJ;AAwEE;EACE,WAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAtEJ;AAyEE;EACE,WAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAvEJ;;AA4EA;EACE,cAAA;AAzEF;;AA4EA;EACE,cAAA;AAzEF;;AA4EA;EACE,cAAA;AAzEF;;AA4EA;EACE,8BAAA;AAzEF;;AA4EA;EACE,8BAAA;AAzEF;;AA4EA;EACE,8BAAA;AAzEF;;AA6EA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;AA1EF;AA4EE;EACE,kBAAA;AA1EJ;AA4EI;EACE,UAAA;EACA,gBAAA;AA1EN;AA6EI;EACE,eAAA;EACA,mBAAA;AA3EN;AA+EE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AA7EJ;AAgFE;EACE,oBAAA;AA9EJ;AAiFE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0BAAA;EACA,sBAAA;EACA,eAAA;AA/EJ;AAkFE;EACE,WAAA;EACA,kBAAA;EACA,6CAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;AAhFJ;AAmFE;EACE,WAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAjFJ;;AAqFA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;AAlFF;;AAqFA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AAlFF;;AAqFA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,+BAAA;EACA,yBAAA;AAlFF;;AAqFA;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAlFF;;AAuFE;EAEE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AArFJ;AAwFE;EACE,cAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtFJ;;AA0FA;EACE,WAAA;EACA,8BAAA;AAvFF;;AA0FA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AAvFF;AAyFE;;EAEE,+BAAA;EACA,iBAAA;EACA,6CAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;AAvFJ;AA0FE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAxFJ;;AA4FA;EACE,iBAAA;EACA,kBAAA;AAzFF;AA2FE;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAzFJ;;AA8FA;EACE,uBAAA;AA3FF;AA8FI;EACE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AA5FN;AA+FI;EACE,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA7FN;AAiGE;EAWE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,yDAAA;AAzGJ;AA4GI;EACE,YAAA;EACA,YAAA;EACA,6CAAA;EACA,oBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AA1GN;AA6GI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA3GN;;AAmHA;EACE,kBAAA;EACA,gBAAA;EAwIA,sBAAA;AAvPF;AAiHE;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA/GJ;AAkHE;EACE,mBAAA;AAhHJ;AAoHE;EACE,cAAA;EACA,mBAAA;AAlHJ;AAqHE;EACE,WAAA;EACA,WAAA;EACA,UAAA;AAnHJ;AAsHE;EACE,WAAA;EACA,WAAA;AApHJ;AAuHE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AArHJ;AAwHE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAtHJ;AAyHE;EACE,aAAA;AAvHJ;AA0HE;EACE,cAAA;AAxHJ;AA4HE;EACE;IACE,aAAA;EA1HJ;EA6HE;IACE,aAAA;EA3HJ;EA8HE;IACE,UAAA;IACA,WAAA;EA5HJ;EA+HE;IACE,UAAA;IACA,YAAA;EA7HJ;EAgIE;IACE,gBAAA;EA9HJ;EAiIE;IACE,cAAA;EA/HJ;EAkIE;IACE,aAAA;EAhIJ;AACF;AAmIE;EACE,yBAAA;AAjIJ;AAoIE;EACE,wCAAA;AAlIJ;AAqIE;EACE,kBAAA;EACA,YAAA;AAnIJ;AAqII;EACE,yBAAA;EACA,6CAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAnIN;AAsII;EACE,yBAAA;EACA,6CAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AApIN;AAwIE;EACE,gCAAA;EACA,yDAAA;EACA,uCAAA;EACA,4CAAA;AAtIJ;AAyIE;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;AAvIJ;;AA6IA;EACE,gCAAA;EACA,sCAAA;EACA,uCAAA;AA1IF;;AA6IA;EACE,gBAAA;AA1IF;AA4IE;EACE,oBAAA;EACA,kBAAA;AA1IJ;AA4II;EACE,qCAAA;EACA,6CAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA1IN;;AA+IA;EACE,iBAAA;AA5IF;AA8IE;EACE,gCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA5IJ;AA+IE;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,8BAAA;EACA,oDAAA;EACA,mBAAA;AA7IJ;AAgJE;EACE,sBAAA;AA9IJ;AAiJE;EACE,kCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA/IJ;AAkJE;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAhJJ;AAmJE;EACE,mBAAA;AAjJJ;AAoJE;EACE,kCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAlJJ;AAqJE;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAnJJ","sourcesContent":["ion-header.title {\n  &::after {\n    height: var(--unit-xxxsm);\n    bottom: calc(var(--unit-xxxsm) * -1);\n  }\n\n  ion-title {\n    color: var(--Brand-Primario, #0554F2);\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    top: 22px;\n  }\n\n  .subtitle {\n    padding-inline: var(--unit-lg);\n    width: 100%;\n\n    ion-label {\n      font-size: var(--font-md);\n      font-weight: 400;\n      --color: var(--ion-color-info-text);\n    }\n  }\n}\n\nion-toolbar .close-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.ios-modal ion-toolbar:first-of-type {\n  padding-top: 10px !important;\n}\n\n.config-title {\n  color: var(--ion-color-primary);\n}\n\n.no-qr {\n  width: 229px;\n  height: 239px;\n  text-align: center;\n  background: #fff;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n\n  ion-spinner {\n    margin: 0 auto;\n    top: 0;\n    bottom: 0;\n  }\n}\n\nion-header {\n  ion-toolbar {\n    --background: #fff;\n\n    ion-icon {\n      margin-right: 24px;\n      width: 32px;\n      height: 32px;\n    }\n  }\n}\n\nion-header.search {\n  background: transparent;\n  padding: var(--unit-md);\n\n  &::after {\n    background-image: none;\n  }\n}\n\nion-content {\n  --background: var(--ion-color-primary-contrast);\n  --padding-bottom: var(--unit-xxxsm);\n}\n\nion-footer {\n  --background: transparent;\n\n  ion-toolbar {\n    --border-width: 0;\n    --padding-end: 0;\n    --padding-start: 0;\n    border-top-left-radius: var(--radius-md);\n    border-top-right-radius: var(--radius-md);\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);\n  }\n\n  ion-grid {\n    ion-button {\n      width: auto;\n    }\n  }\n}\n\nion-col.value {\n  font-weight: 600;\n}\n\nspan.no-wrap {\n  white-space: initial;\n}\n\n.multiAccordion {\n  ion-list[slot=\"content\"] {\n    border-bottom: 1px solid var(--ion-item-border-color);\n  }\n\n  &:last-of-type {\n    ion-item[slot=\"header\"] {\n      --border-color: var(--ion-item-border-color);\n      --border-style: solid;\n      --border-width: 0 0 1px 0;\n    }\n  }\n\n  &.accordion-expanding,\n  &.accordion-expanded {\n    &:last-of-type {\n      ion-item[slot=\"header\"] {\n        --border-width: 0;\n      }\n\n      ion-list[slot=\"content\"] {\n        border-bottom: none;\n      }\n    }\n  }\n}\n\n.btn-flag {\n  margin-right: var(--unit-xsm);\n  height: calc(var(--unit-md) + 2px);\n  border-radius: var(--radius-xxsm);\n}\n\nion-icon[slot=\"start\"] {\n  font-size: var(--unit-xxxlg);\n  width: var(--unit-xxxlg);\n  height: var(--unit-xxxlg);\n  margin-inline-end: 0;\n\n  &.opt {\n    // color: #ffffff;\n    // background: var(--ion-color-primary);\n    // width: 22px;\n    // height: 22px;\n    // border-radius: 50%;\n    // padding: 8px;\n    // margin-right: 10px;\n\n    color: #ffffff;\n    background: var(--ion-color-primary);\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    margin-right: 10px;\n  }\n\n  &.custom {\n    color: #ffffff;\n    background: var(--ion-color-primary);\n    width: 22px;\n    height: 22px;\n    padding: 6px;\n    border-radius: 50%;\n    margin-right: 10px;\n  }\n\n  &.clean {\n    width: 24px !important;\n    height: 24px !important;\n    padding: 6px;\n    border-radius: 50%;\n    margin-right: 10px;\n    background: #ffffff;\n    margin-bottom: 8px;\n    position: relative;\n    bottom: 4px;\n  }\n\n  &.icon-VENTASCLICK {\n    color: #3889F2;\n  }\n\n  &.icon-default {\n    color: var(--ion-color-primary);\n  }\n}\n\n.error-advice {\n  color: var(--ion-color-danger);\n}\n\n\n\n#containerQR {\n  position: absolute;\n  top: 0px;\n  z-index: 9;\n  margin: 0 auto;\n  width: 100%;\n\n  p {\n    color: #FFF;\n    font-family: Montserrat;\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: -0.009px;\n    margin: 16px 26px 31px 26px;\n  }\n}\n\nsection {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 400px;\n  padding-top: 100px;\n  background: var(--ion-color-primary);\n}\n\n.curve {\n  position: absolute;\n  height: 250px;\n  width: 100%;\n  bottom: 0;\n  text-align: center;\n}\n\n.curve::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  border-radius: 169% 159%;\n  width: 150%;\n  height: 67%;\n  left: 0px;\n  bottom: 21px;\n  transform: translate(-16%, 62%);\n  background-color: #ffffff;\n}\n\n\n.boxx-btn {\n  height: 13vw !important;\n  min-height: 13vw !important;\n  margin: 0px 4px;\n}\n\n.btn-register {\n  --border-radius: 16px;\n  margin-bottom: 24px;\n  text-align: center;\n  font-feature-settings: \"liga\" off, \"clig\" off;\n  font-family: 'Poppins';\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: math-auto;\n}\n\n.btn-manual {\n  font-weight: 500;\n}\n\n.attendee-avatar-container {\n  display: flex;\n  align-items: flex-end;\n  white-space: initial;\n  font-size: small;\n\n  ion-avatar {\n    min-width: 24px;\n    width: 24px;\n    height: 24px;\n    font-size: 12px;\n    font-weight: 500;\n    margin-right: 6px;\n    padding: 0;\n    border: 0;\n\n    div {\n      background: var(--ion-color-primary);\n      color: #ffffff;\n    }\n  }\n}\n\n.container-detail {\n  border-radius: 8px;\n  background: #FFF;\n  //box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 0px 24px 16px 24px;\n\n  .detail-title {\n    color: #07192F;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 34px;\n    margin-bottom: 8px;\n    margin-top: 0px;\n  }\n\n  .detail-dates {\n    color: #F20F0F;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 22px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  .detail-title-form {\n    color: #0C2340;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    margin-top: 11px;\n    margin-bottom: 8px;\n  }\n\n  .detail-desc {\n    color: #43556A;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 22px;\n    margin-top: 8px;\n  }\n\n  .detail-link {\n    color: var(--ion-color-primary);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 22px;\n    margin-top: 8px;\n  }\n\n  .container-actions {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    padding-left: 20px\n  }\n\n}\n\n.qr-container {\n  margin-top: -9px;\n\n  img {\n    min-width: 297px;\n    min-height: 297px;\n  }\n}\n\n.sw-qr {\n  position: absolute;\n  top: 0px;\n  z-index: 9;\n  margin: 0 auto;\n  width: 100%;\n}\n\n\n//Rediseño\n#contact-type {\n\n  padding: 0px 16px;\n\n  ion-item {\n    --padding-start: 0px;\n    --padding-end: 0px;\n  }\n\n\n  .icon-type {\n    width: 32px;\n    height: 32px;\n    padding-right: 18px;\n  }\n\n  ion-label {\n    color: var(--text-Subttulos, #0D253A);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .unqualified {\n    color: #515356;\n  }\n\n  .prospect {\n    color: #FF9900;\n  }\n\n  .client {\n    color: #00A569;\n  }\n\n  .discarded {\n    color: #DC3839;\n  }\n}\n\n#custom-options {\n  // padding: 0px 16px;\n  padding: 0px 24px;\n\n  ion-item {\n    --padding-start: 0px;\n    --padding-end: 0px;\n\n    .c-detail {\n      margin-left: 0;\n      margin-right: 0;\n      margin-top: 0;\n      margin-bottom: 2px;\n      font-size: 0.875rem;\n      line-height: 1.25rem;\n      text-overflow: inherit;\n      overflow: inherit;\n      color: var(--ion-color-step-600, #666666);\n    }\n  }\n\n  .icon-src {\n    width: 32px;\n    height: 32px;\n    padding: 6px;\n    border-radius: 50%;\n    margin-right: 10px;\n    background: #ffffff;\n    margin-bottom: 8px;\n  }\n\n  ion-label {\n    color: var(--text-Subttulos, #0D253A);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-bottom: 5px;\n    margin-top: 9px;\n  }\n\n\n  .subtitle{\n    color: #000;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-align: center;\n    margin: 0px;\n    padding: 0px 40px;\n    margin-bottom: 10px;\n  }\n\n  .benefit{\n    color: #000;\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    padding: 11px 0px;\n  }\n}\n\n\n.completed {\n  color: #099F69;\n}\n\n.to-do {\n  color: #D50000;\n}\n\n.in-progress {\n  color: #C97B07;\n}\n\n.high {\n  background: #EC0000 !important;\n}\n\n.low {\n  background: #0554F2 !important;\n}\n\n.half {\n  background: #FF8A00 !important;\n}\n\n\n#containerQR {\n  position: absolute;\n  top: 0px;\n  z-index: 9;\n  margin: 0 auto;\n  width: 100%;\n\n  .cont-img {\n    position: relative;\n\n    .img-nfc {\n      width: 81%;\n      margin-top: 17px;\n    }\n\n    .mt-success {\n      margin-top: 17%;\n      margin-bottom: 14px;\n    }\n  }\n\n  .success {\n    position: absolute;\n    top: 32%;\n    left: 50%;\n    width: 32%;\n    transform: translate(-50%, -50%);\n  }\n\n  .tt-none {\n    text-transform: none;\n  }\n\n  p {\n    color: #FFF;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: -0.009px;\n    margin: 8px 26px 31px 26px;\n    font-family: 'Poppins';\n    font-size: 30px;\n  }\n\n  .nfc-text {\n    color: #FFF;\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: Poppins;\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: -0.009px;\n    margin: 12px 39px 23px 39px;\n  }\n\n  .nfc-detail {\n    color: #FFF;\n    text-align: center;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: \"Poppins\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin: 2px 74px;\n    margin-bottom: 73px;\n  }\n}\n\nsection {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 400px;\n  padding-top: 100px;\n  background: var(--ion-color-primary);\n}\n\n.curve {\n  position: absolute;\n  height: 250px;\n  width: 100%;\n  bottom: 0;\n  text-align: center;\n}\n\n.curve::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  border-radius: 169% 159%;\n  width: 150%;\n  height: 67%;\n  left: 0px;\n  bottom: 21px;\n  transform: translate(-16%, 62%);\n  background-color: #ffffff;\n}\n\n.nfc-item-form {\n  margin-bottom: 16px;\n  --padding-start: 16px;\n  --padding-end: 16px;\n  border-radius: 8px;\n  border: 1px solid #076DF2;\n  background: #FFF;\n\n}\n\n.nfc-item-form {\n  ::ng-deep .custom-input .label-text {\n\n    color: #0554F2 !important;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: \"Roboto\";\n    font-size: 16px !important;\n  }\n\n  ::ng-deep .custom-input {\n    color: #2C4051;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n.custom-input::part(native) {\n  color: gray;\n  /* Para el texto del prefijo */\n}\n\n#container-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  border-bottom: 1px solid #f0f0f0;\n\n  .cancel,\n  .accept {\n    color: var(--ion-color-primary);\n    text-align: right;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: -0.4px;\n    font-size: 14px !important;\n    text-transform: initial;\n  }\n\n  .title {\n    color: #000;\n    text-align: center;\n    font-family: \"Poppins\";\n    font-size: 14px !important;\n    text-transform: initial;\n    font-style: normal;\n    font-weight: 590;\n    line-height: 18px;\n  }\n}\n\n.custom-search-bar {\n  padding: 0px 16px;\n  --padding-top: 0px;\n\n  ion-searchbar {\n    border-radius: 16px;\n    --border-radius: 16px;\n    height: 56px;\n    --padding-start: 16px;\n    --padding-end: 16px;\n    border: 2px solid #ede9e9;\n    min-height: 56px;\n    margin: 0px;\n  }\n}\n\n//Search box\n.search-form {\n  background: transparent;\n\n  .custom-item-form {\n    ::ng-deep .custom-input .label-text {\n      color: #0D253A !important;\n      font-feature-settings: \"liga\" off, \"clig\" off;\n      font-family: \"Roboto\";\n      font-size: 16px !important;\n    }\n\n    ::ng-deep .custom-input {\n      color: #0D253A !important;\n      font-family: \"Poppins\";\n      font-size: 16px !important;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      margin-bottom: 0px;\n    }\n  }\n\n  .custom-item-form {\n    // border: 2px solid #ede9e9;\n    // margin-bottom: 16px;\n    // min-height: 56px;\n    // background: white;\n    // --border-radius: 50px;\n    // border-radius: 50px;\n    // height: 56px;\n    // --padding-start: 16px;\n    // --padding-end: 16px;\n\n    border: 2px solid #ede9e9;\n    margin-bottom: 8px;\n    --border-radius: 50px;\n    height: 40px;\n    --padding-start: 16px;\n    --padding-end: 16px;\n    border-radius: 12px;\n    background: var(--Input-Box-Empty-Abled, #FFF);\n    box-shadow: 0px 0px 3px 1px rgba(83, 127, 171, 0.20) inset;\n\n\n    .custom-input {\n      resize: none;\n      bottom: 17px;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: Poppins;\n      font-size: 12px !important;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      height: 40px;\n    }\n\n    .custom-search-icon {\n      margin: 0px;\n      position: relative;\n      bottom: 16px;\n      width: 20px;\n    }\n\n  }\n\n}\n\n\n#content-schedule {\n  padding: 16px 24px;\n  background: #fff;\n\n  .title {\n    color: var(--text-BODY, #2C4051);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n\n  hr {\n    background: #D8D8D8;\n  }\n\n\n  ion-datetime {\n    margin: 0 auto;\n    background: #f8f9fb;\n  }\n\n  .date-content {\n    width: 100%;\n    float: none;\n    z-index: 9;\n  }\n\n  .time-content {\n    width: 100%;\n    float: none;\n  }\n\n  .label-date {\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n  }\n\n  .label-time {\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n  }\n\n  .buttonPWA {\n    display: none;\n  }\n\n  .buttonMobile {\n    display: block;\n  }\n\n  //PWA\n  @media (min-width: 960px) {\n    .label-date {\n      display: none;\n    }\n\n    .label-time {\n      display: none;\n    }\n\n    .date-content {\n      width: 50%;\n      float: left;\n    }\n\n    .time-content {\n      width: 50%;\n      float: right;\n    }\n\n    .time-pwa {\n      padding-top: 12%;\n    }\n\n    .buttonPWA {\n      display: block;\n    }\n\n    .buttonMobile {\n      display: none;\n    }\n  }\n\n  .boxx-btn {\n    text-transform: uppercase;\n  }\n\n  .custom-title {\n    color: var(--ion-color-light) !important;\n  }\n\n  .enable-item {\n    border-radius: 0px;\n    border: none;\n\n    ion-label {\n      color: #425F81 !important;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: Poppins !important;\n      font-size: 16px !important;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      position: relative;\n      top: 3px;\n    }\n\n    .hour {\n      color: #12384F !important;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: Poppins !important;\n      font-size: 16px !important;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      position: relative;\n      top: 3px;\n    }\n  }\n\n  ion-toggle {\n    --background: #dfdfdf !important;\n    --background-checked: var(--ion-color-primary) !important;\n    --handle-background: #ffffff !important;\n    --handle-background-checked: #fff !important;\n  }\n\n  ion-toggle[slot=end] {\n    margin-top: 12px;\n    margin-bottom: 12px;\n    padding: 0;\n  }\n\n  --padding-bottom: 56px;\n}\n\nswiper-container {\n  --swiper-pagination-bottom: 30px;\n  --swiper-pagination-bullet-width: 16px;\n  --swiper-pagination-bullet-height: 16px;\n}\n\n.languages-list {\n  margin: 0px 16px;\n\n  ion-item {\n    --padding-start: 8px;\n    --padding-end: 8px;\n\n    ion-label {\n      color: var(--text-Subttulos, #0D253A);\n      font-feature-settings: 'liga' off, 'clig' off;\n      /* Body/Body Resultados */\n      font-family: Poppins;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n}\n\n#gbp-options {\n  padding: 0px 16px;\n\n  .custom-main-title{\n    color: var(--text-BODY, #2C4051);\n    text-align: center;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-align: center;\n    padding: 0px 24px;\n    margin-top: 8px;\n  }\n\n  div{\n    background-color: white;\n    border-radius: 16px;\n    padding: 16px;\n    margin: 10px 0;\n    width: 100%;\n    fill: var(--Color-cards, #FFF);\n    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.15));\n    margin-bottom: 16px;\n  }\n\n  .index-selected{\n    border: 1px solid blue;\n  }\n  \n  .name {\n    color: var(--text-Ttulos, #0D253A);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-bottom: 0px;\n  }\n\n  .category {\n    color: var(--text-Info, #788089);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 0px;\n  }\n\n  hr{\n    background: #D8D8D8;\n  }\n\n  .title {\n    color: var(--text-Ttulos, #0D253A);\n    font-family: 'Poppins';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-bottom: 2px;\n  }\n\n  .detail {\n    color: var(--text-BODY, #2C4051);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
